module.exports = __webpack_public_path__ + "img/top.530af848.png";